<template>
  <div class="vgt-bb-filter">
    <div v-if="isDropdownMultiselect(column)">
      <div style="position: relative; overflow: hidden;">
        <MultiSelectSearchable
          :list="column.filterOptions.filterDropdownItems"
          :id="column.field"
          @updateFilterCustom="updateFilterCustom"
        />
      </div>
    </div>

    <div v-else-if="isFilterable(column)">
      <div v-if="column.filterOptions.filterType === 'dateRange'" class="bbDateFilter">
        <div class>
          <input
            type="date"
            placeholder="Start Date"
            @change="updateFilters(column, $event.target.value)"
          />
        </div>
        <div class>
          <input
            type="date"
            placeholder="End Date"
            @change="updateFilters(column, $event.target.value, 'end')"
          />
        </div>
      </div>

      <input
        v-if="!column.filterOptions.filterType && !isDropdown(column)"
        type="text"
        ref="filterText"
        class="vgt-input"
        :placeholder="getPlaceholder(column)"
        :value="columnFilters[column.field]"
        @keyup.enter="updateFiltersOnEnter(column, $event.target.value)"
        @input="updateFiltersOnKeyup(column, $event.target.value)"
      />

      <!-- options are a list of primitives -->
      <select
        v-if="isDropdownArray(column)"
        class="vgt-select"
        :value="columnFilters[column.field]"
        @change="updateFilters(column, $event.target.value)"
      >
        <option value key="-1">{{ getPlaceholder(column) }}</option>
        <option
          v-for="(option, i) in column.filterOptions.filterDropdownItems"
          :key="i"
          :value="option"
        >{{ option }}</option>
      </select>

      <!-- options are a list of objects with text and value -->
      <select
        v-if="isDropdownObjects(column)"
        class="vgt-select"
        :value="columnFilters[column.field]"
        v-on:input="updateFilters(column, $event.target.value, true)"
      >
        <option value key="-1">{{ getPlaceholder(column) }}</option>
        <option
          v-for="(option, i) in column.filterOptions.filterDropdownItems"
          :key="i"
          :value="option.value"
        >{{ option.text }}</option>
      </select>
    </div>
  </div>
</template>

<script>
import isEqual from "lodash.isequal";

import MultiSelectSearchable from "./MultiSelectSearchable";

export default {
  name: "VgtBBFilter",
  props: [
    "column",
    "typedColumns",
    "globalSearchEnabled",
    "selectable",
    "mode",
    "focus",
  ],
  components: {
    MultiSelectSearchable,
  },
  watch: {
    columns: {
      handler(newValue, oldValue) {
        if (!isEqual(newValue, oldValue)) {
          this.populateInitialFilters();
        }
      },
      deep: true,
      immediate: true,
    },
    focus: {
      handler(newValue, oldValue) {
        if (newValue === true) {
          this.$refs.filterText.focus();
        }
      },
      immediate: false,
    },
  },
  data() {
    return {
      columnFilters: {},
      timer: null,
    };
  },
  computed: {
    // to create a filter row, we need to
    // make sure that there is atleast 1 column
    // that requires filtering
    hasFilterRow() {
      // if (this.mode === 'remote' || !this.globalSearchEnabled) {
      for (let i = 0; i < this.columns.length; i++) {
        const col = this.columns[i];
        if (col.filterOptions && col.filterOptions.enabled) {
          return true;
        }
      }
      // }
      return false;
    },
  },
  methods: {
    reset(emitEvent = false) {
      this.columnFilters = {};
      if (emitEvent) {
        this.$emit("filter-changed", this.columnFilters);
      }
    },

    isFilterable(column) {
      return column.filterOptions && column.filterOptions.enabled;
    },

    isDropdown(column) {
      return (
        this.isFilterable(column) &&
        column.filterOptions.filterDropdownItems &&
        column.filterOptions.filterDropdownItems.length
      );
    },

    isDropdownObjects(column) {
      return (
        this.isDropdown(column) &&
        typeof column.filterOptions.filterDropdownItems[0] === "object"
      );
    },

    isDropdownArray(column) {
      return (
        this.isDropdown(column) &&
        typeof column.filterOptions.filterDropdownItems[0] !== "object"
      );
    },

    isDropdownMultiselect(column) {
      return (
        this.isDropdown(column) && column.filterOptions.isMultiselect === true
      );
    },

    // get column's defined placeholder or default one
    getPlaceholder(column) {
      const placeholder =
        (this.isFilterable(column) && column.filterOptions.placeholder) ||
        `Filter ${column.label}`;
      return placeholder;
    },

    updateFiltersOnEnter(column, value) {
      if (this.timer) clearTimeout(this.timer);
      this.updateFiltersImmediately(column, value);
    },

    updateFiltersOnKeyup(column, value) {
      // if the trigger is enter, we don't filter on keyup
      if (column.filterOptions.trigger === "enter") return;
      this.updateFilters(column, value);
    },

    // since vue doesn't detect property addition and deletion, we
    // need to create helper function to set property etc
    updateFilters(column, value, attrName = "start") {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (column.filterOptions.filterType === "dateRange") {
          const filterValue = column.filterOptions.filterValue || {};
          column.filterOptions.filterValue = {
            ...filterValue,
            [attrName]: value,
          };
          this.updateFiltersImmediately(
            column,
            column.filterOptions.filterValue
          );
        } else {
          this.updateFiltersImmediately(column, value);
        }
      }, 400);
    },

    updateFilterCustom(value) {
      if (this.timer) clearTimeout(this.timer);
      this.updateFiltersImmediately(this.column, value);
    },

    updateFiltersImmediately(column, value) {
      const field =
        column.filterOptions && column.filterOptions.fieldNameFilter
          ? column.filterOptions.fieldNameFilter
          : column.field;
      this.$set(this.columnFilters, field, value);
      this.$emit("filter-changed", this.columnFilters);

      console.log("this.columnFilters", this.columnFilters);
    },

    populateInitialFilters() {
      for (let i = 0; i < this.columns.length; i++) {
        const col = this.columns[i];
        // lets see if there are initial
        // filters supplied by user
        if (
          this.isFilterable(col) &&
          typeof col.filterOptions.filterValue !== "undefined" &&
          col.filterOptions.filterValue !== null
        ) {
          this.$set(
            this.columnFilters,
            col.field,
            col.filterOptions.filterValue
          );
          // this.updateFilters(col, col.filterOptions.filterValue);
          this.$set(col.filterOptions, "filterValue", undefined);
        }
      }
      //* lets emit event once all filters are set
      this.$emit("filter-changed", this.columnFilters);
    },
  },
  mounted() {},
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/vendors/vue-good-table/components/VgtBBFilter.vue